// extracted by mini-css-extract-plugin
export var animationContainer = "_mm-0";
export var footer = "_mm-1";
export var gray = "_mm-2";
export var lineItem = "_mm-3";
export var lineItemImage = "_mm-4";
export var lineItemInfo = "_mm-5";
export var lineItemText = "_mm-6";
export var lineItems = "_mm-7";
export var modalContent = "_mm-8";
export var options = "_mm-9";
export var orderName = "_mm-a";
export var refundAmount = "_mm-b";